/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import RelatedApps from './relatedApps';
import HelpAndSupport from './helpAndSupport';
import Information from './information';
import StayConnected from './stayConnected';
import Categories from './categories';
import OtherPlatforms from './otherPlatforms';
import './rightPanel.scss';
import { setCSSProperty, convertPixelPropertyToNum } from '../../../../utils/cssUtils';

class PDPRightPanel extends Component {
    componentWillMount() {
        window.addEventListener('resize', this.windowResizeListener.bind(this));
    }

    componentDidMount() {
        this.setPanelHeight();
    }

    componentDidUpdate() {
        this.setPanelHeight();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.windowResizeListener.bind(this));
    }

    setPanelHeight() {
        const sectionHeights = [];
        const sections = ['categories', 'help-and-support', 'information', 'other-platforms', 'related-apps', 'stay-connected'];
        sections.forEach((sectionClassName) => {
            const sectionElem = document.getElementsByClassName(sectionClassName)[0];
            if (sectionElem) {
                const sectionStyle = window.getComputedStyle(sectionElem);
                const sectionHeight = convertPixelPropertyToNum(sectionStyle.height)
                    + convertPixelPropertyToNum(sectionStyle.marginBottom)
                    + convertPixelPropertyToNum(sectionStyle.marginTop);
                sectionHeights.push(sectionHeight);
            }
        });
        let totalHeight = 0;
        totalHeight = sectionHeights.reduce((a, b) => a + b, 0);
        totalHeight = (totalHeight / 2) + 112;
        const rightPanelCompt = document.getElementsByClassName('pdp-body-right-panel')[0];
        if (window.matchMedia
            && window.matchMedia('(min-width: 584px)').matches
            && window.matchMedia('(max-width: 960px)').matches) {
            setCSSProperty(rightPanelCompt, 'height', `${totalHeight}px`);
        } else {
            setCSSProperty(rightPanelCompt, 'height', '');
        }
    }

    windowResizeListener() {
        const self = this;
        if (typeof this.timerResize !== 'undefined') {
            clearTimeout(this.timerResize);
        }
        this.timerResize = setTimeout(() => {
            self.setPanelHeight();
        }, 20);
    }

    render() {
        const { PDPDataObject, appsList, appsPanelSkeleton } = this.props;
        return (
            <div className="pdp-body-right-panel">
                <Categories PDPDataObject={PDPDataObject} appsPanelSkeleton={appsPanelSkeleton} />
                <OtherPlatforms PDPDataObject={PDPDataObject} appsList={appsList} />
                <Information PDPDataObject={PDPDataObject} appsList={appsList} />
                <HelpAndSupport PDPDataObject={PDPDataObject} />
                <RelatedApps PDPDataObject={PDPDataObject} appsList={appsList} />
                <StayConnected PDPDataObject={PDPDataObject} />
            </div>
        );
    }
}

export default observer(PDPRightPanel);
